// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4VPJi","box":"styles_box__GUZUv","icon":"styles_icon__UC9_k"};